<h1 mat-dialog-title>{{ data.dialogTitle }}</h1>
<div mat-dialog-content>
  <form class="edit-report-source-dialog-form">
    <mat-form-field>
      <mat-label>Layout Name</mat-label>
      <input matInput name="layoutName" [(ngModel)]="layoutName" />
    </mat-form-field><br />
    <mat-form-field>
      <mat-label>Subscription</mat-label>
      <mat-select name="subscriptionId" [(ngModel)]="subscriptionId">
        <mat-option *ngFor="let subscription of subscriptions" [value]="subscription.subscriptionId">{{ subscription.subscriptionName }}</mat-option>
      </mat-select>
    </mat-form-field><br />
    <!--<mat-form-field>
      <mat-label>Pre-Filter</mat-label>
      <mat-select name="preFilterId" [(ngModel)]="preFilterId">
        <mat-option [value]="-1">Default Pre-Filter</mat-option>
        <mat-option *ngFor="let preFilter of preFilters" [value]="preFilter.preFilterId">{{ preFilter.name }}</mat-option>
      </mat-select>
    </mat-form-field><br />-->
    <ng-container>
      <div width="80%">
        <mat-form-field>
          <mat-label>Select Available Page</mat-label>
          <mat-select name="selectedReportPage" [(ngModel)]="selectedReportPage">
            <mat-option *ngFor="let reportPage of availablePages" [value]="reportPage">{{ reportPage }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div width="20%">
        <button mat-raised-button class="piButton" (click)="addReportPage()">Add Page</button>
      </div>
    </ng-container><br />
    <ng-container>
      <table>
        <thead>
          <tr>
            <th>Page</th>
            <th></th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let reportPage of reportPages; index as i">
            <td>{{ reportPage }}</td>
            <td>&nbsp;&nbsp;<a href="#" (click)="removeReportPage(reportPage)">Remove</a>&nbsp;&nbsp;</td>
            <td>&nbsp;&nbsp;<a *ngIf="i > 0" href="#" (click)="movePageUp(i)">Move Up&nbsp;&nbsp;</a></td>
            <td>&nbsp;&nbsp;<a *ngIf="i < (reportPages.length -1)" href="#" (click)="movePageDown(i)">Move Down</a>&nbsp;&nbsp;</td>
          </tr>
        </tbody>
      </table>
    </ng-container><br />
    <!--<ng-container>
      <div [style]="colorDisplay()"></div>
    </ng-container>
    <mat-form-field>
      <mat-label>Background Color</mat-label>
      <input matInput [ngxMatColorPicker]="picker" name="bgColor" [(ngModel)]="bgColor">
      <ngx-mat-color-toggle matSuffix [for]="picker"></ngx-mat-color-toggle>
      <ngx-mat-color-picker #picker [color]="bgColor"></ngx-mat-color-picker>
    </mat-form-field><br />
    <ng-container *ngIf="headerImageSrc != undefined">
      <img [src]="headerImageSrc" style="width: 100%" />
    </ng-container>
    <ng-container><br />
      <mat-label>Header Image File</mat-label>
      <input type="file" id="headerFile" (change)="readHeaderImage($event.target.files)" />
      <button mat-raised-button (click)="clearHeaderImage()">Clear Header Image</button>
    </ng-container><br />
    <ng-container *ngIf="footerImageSrc != undefined">
      <img [src]="footerImageSrc" style="width:100%" />
    </ng-container><br />
    <ng-container>
      <mat-label>Footer Image File</mat-label>
      <input type="file" id="footerFile" (change)="readFooterImage($event.target.files)" />
      <button mat-raised-button (click)="clearFooterImage()">Clear Footer Image</button>
    </ng-container>-->
  </form>
</div>
<div mat-dialog-actions>
  <button mat-raised-button
          class="piButton"
          (click)="onConfirmClick()"
          cdkFocusInitial>
    Confirm
  </button>
  <button mat-raised-button (click)="onCancelClick()">Cancel</button>
</div>
